/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonMenuIcon/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonMenuIcon({
  children,
  viewPath = "/DesignSystem/ButtonMenuIcon",
  paddingLeft = 4,
  paddingRight = 4,
  paddingTop = 4,
  paddingBottom = 4,
  marginRight = 4,
  marginTop = 4,
  onClick,
  isSelected,
  text = "Label"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="ButtonMenuIcon.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pl-2-Z1xaxqb': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-3-Z1xaxqb': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-4-Z1xaxqb': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-5-Z1xaxqb': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--mr-6-Z1xaxqb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-7-Z1xaxqb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--bc-1-Z1xaxqb': isSelected ? "rgba(0,188,112, 0.1)" : isHovered ? "rgba(111,111,111, 0.1)" : "rgba(111,111,111, 0)"}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="semibold"
 marginLeft={8}
 text={text}
 color={isSelected ? "rgba(0,188,112, 1)" : "#303030"}
/>
</button>
</React.Fragment>)
}